import React from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, Star, ExternalLink } from 'lucide-react';

const AboutUs: React.FC = () => {
    return (
        <section id="about" className="relative py-20 overflow-hidden">
            {/* Background decorations */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/2 left-10 w-32 h-32 bg-primary-500/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-10 right-10 w-40 h-40 bg-accent-500/20 rounded-full blur-3xl animate-pulse delay-700"></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="max-w-4xl mx-auto text-center"
                >
                    <h2 className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary-300 via-white to-accent-300 mb-8 drop-shadow-sm">
                        Par Mums
                    </h2>

                    <div className="inline-flex items-center justify-center p-3 bg-white/10 backdrop-blur-md rounded-full mb-8 shadow-xl border border-white/20">
                        <Heart className="w-6 h-6 text-red-400 mr-2" />
                        <span className="text-white font-bold tracking-wide">Mūsu Sirds</span>
                    </div>

                    <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-2xl border border-white/10 transform hover:scale-[1.02] transition-transform duration-500">
                        <p className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-8">
                            Šo pasākumu organizē tā pati komanda, kas veidoja neaizmirstamo <span className="text-accent-300 font-bold">"SuperWeek"</span> vasaras nometni.
                        </p>

                        <p className="text-lg text-gray-300 leading-relaxed mb-8">
                            Mēs esam brīvprātīgo kristiešu komanda, kuru sirdslieta ir dalīties ar <span className="text-primary-300 font-bold">Jēzus mīlestību</span> un prieku, īpaši šeit, Viļānos.
                        </p>

                        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mt-10">
                            {/* <div className="flex items-center gap-3 bg-white/5 py-3 px-6 rounded-2xl border border-white/5">
                                <Users className="w-5 h-5 text-secondary-400" />
                                <span className="text-gray-300 font-medium">Brīvprātīgo komanda</span>
                            </div> */}

                            <a
                                href="https://superweek.lv"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-accent-300 hover:text-accent-200 font-bold transition-colors group"
                            >
                                <span>Apmeklēt superweek.lv</span>
                                <ExternalLink className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                            </a>
                        </div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.5 }}
                        className="mt-8 text-sm text-gray-400"
                    >
                        Visi organizētāji darbojas brīvprātīgi, lai radītu īpašus svētkus tieši jums.
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default AboutUs;
